import {mapActions, mapGetters, mapMutations} from "vuex";

export default {
    name: 'basket-product',
    data() {
        return {
        }
    },
    props: {
        item: {
            type: Object,
            default: () => {
            }
        }
    },
    created() {
        // this.updateQuality()
    },
    computed: {
        ...mapGetters({
            getCurrentOrder: 'order/getCurrentOrder'
        })
    },
    methods: {
        ...mapMutations({
            updateBasket: 'order/ADD_BASKET',
            increment: 'order/INCREMENT_BASKET_LIST_COUNT',
            decrement: 'order/DECREMENT_BASKET_LIST_COUNT',
            remove:'order/REMOVE_ITEM_FROM_BASKET'
        }),

    }

}
